module.exports = __webpack_public_path__ + "img/2-1.b2d635d6.jpg";